import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';
import '../../styles/coffee.css';

const Coffee = () => {
    const { language } = useLanguage();
    const { t } = useTranslation(language);

    const handlePayPalClick = () => {
        window.open('https://ko-fi.com/foundly', '_blank');
    };

    return (
        <div className="coffee-page">
            <div className="coffee-shell">
                <div className="coffee-visual">
                    <div className="coffee-visual__img">
                        <img
                            src={`${process.env.PUBLIC_URL}/img/caffe.jpg`}
                            alt=""
                        />
                    </div>
                </div>

                <div className="coffee-copy">
                    <h2 className="coffee-copy__title">{t('coffee.title')}</h2>
                    <p className="coffee-copy__subtitle">{t('coffee.subtitle')}</p>
                    <p className="coffee-copy__body">{t('coffee.description1')}</p>

                    <button
                        type="button"
                        onClick={handlePayPalClick}
                        className="coffee-copy__cta"
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/img/ko-fi.png`}
                            alt=""
                        />
                        {t('coffee.donateButton')}
                    </button>

                    <p className="coffee-copy__thanks">{t('coffee.thankYou')}</p>
                </div>
            </div>
        </div>
    );
};

export default Coffee;
